export const determinadoTemplate = `
<div id="document-template" class="contract-template">
    <style>
        .contract-template {
            width: 210mm;
            min-height: 297mm;
            padding: 20mm;
            background: white;
            font-family: 'Arial', sans-serif;
            line-height: 1.6;
            box-sizing: border-box;
            font-size: 12px;
        }
        .contract-header {
            text-align: center;
            margin-bottom: 2rem;
            border-bottom: 2px solid #333;
            padding-bottom: 1rem;
        }
        .contract-header h1 {
            font-size: 18px;
            margin: 0;
            font-weight: bold;
            text-transform: uppercase;
        }
        .contract-content {
            text-align: justify;
        }
        .contract-content h5 {
            font-size: 12px;
            margin: 1rem 0 0.5rem 0;
            font-weight: bold;
        }
        .declaration-section {
            margin-bottom: 1.5rem;
        }
        .declaration-title {
            font-weight: bold;
            margin-bottom: 0.5rem;
        }
        .declaration-list {
            list-style-type: upper-latin;
            margin: 0.5rem 0;
            padding-left: 1.5rem;
        }
        .declaration-list li {
            margin-bottom: 0.5rem;
            text-align: justify;
        }
        .clause-list {
            list-style-type: decimal;
            margin: 0.5rem 0;
            padding-left: 1.5rem;
        }
        .clause-list li {
            margin-bottom: 1rem;
            text-align: justify;
        }
        .clause-list .sub-clause {
            list-style-type: lower-alpha;
            margin: 0.5rem 0;
            padding-left: 1.5rem;
        }
        .clause-list .sub-clause li {
            margin-bottom: 0.3rem;
        }
        .signature-section {
            display: flex;
            justify-content: space-between;
            margin-top: 3rem;
        }
        .signature-block {
            text-align: center;
            width: 45%;
        }
        .signature-line {
            margin-top: 4rem;
            border-top: 1px solid #000;
            padding-top: 0.5rem;
        }
        .footer {
            text-align: center;
            margin-top: 2rem;
            font-size: 10px;
            color: #666;
        }
        .bordered-table {
            width: 100%;
            border-collapse: collapse;
            margin: 0.5rem 0;
        }
        .bordered-table td {
            border: 1px solid #000;
            padding: 4px 8px;
            text-align: center;
        }
        .text-bold {
            font-weight: bold;
        }
        .text-underline {
            text-decoration: underline;
        }
        .vacation-table {
            width: 80%;
            margin: 0.5rem auto;
            border-collapse: collapse;
        }
        .vacation-table td {
            border: 1px solid #000;
            padding: 4px;
            text-align: center;
        }
    </style>

    <div class="contract-header">
        <h1>CONTRATO INDIVIDUAL DE TRABAJO POR OBRA DETERMINADA</h1>
    </div>

    <div class="contract-content">
        <p>
            Por medio del presente contrato individual de trabajo, comparece por una parte, 
            <span class="text-bold">[patron]</span>, 
            representada por el(la) C. <span class="text-bold">[representante_legal]</span>, 
            a quien en lo sucesivo se le denominará <span class="text-bold">"EL PATRÓN"</span>. 
            Por la otra parte, comparece el/la C. <span class="text-bold">[colaborador]</span>, 
            quien comparece por su propio derecho y a quien en lo sucesivo se le denominará <span class="text-bold">"EL(LA) TRABAJADOR(A)"</span>. 
            Ambos comparecientes, están de acuerdo en sujetarse al tenor de las siguientes declaraciones y cláusulas;
        </p>
        
        <div class="declaration-section">
            <h5>DECLARACIONES:</h5>
            
            <div class="declaration-title">Declara "EL PATRÓN":</div>
            <ol class="declaration-list">
                <li>Tener como principal actividad la de: <span class="text-bold">[actividad]</span></li>
                <li>Tener su domicilio principal en: <span class="text-bold">[domicilio_fiscal]</span></li>
                <li>Tener como sucursal o centro de trabajo el ubicado en: <span class="text-bold">[lugar_trabajo]</span>, lugar donde se prestarán los servicios</li>
                <li>Tener como RFC, el siguiente: <span class="text-bold">[rfc]</span></li>
                <li>Que con fundamento en los artículos 36 de la ley federal del trabajo es deseo de "EL PATRÓN", contratar por obra determinada, los servicios de una persona que se pueda desempeñar en el puesto de <span class="text-bold">[puesto]</span>, a fin de realizar las labores propias del puesto, tales como: <span class="text-bold">[descripcion_puesto]</span>. Así como todas aquellas actividades o servicios que sean compatibles con sus fuerzas, aptitudes, estado o condición y que sea del mismo género de los que formen el objeto de la empresa o establecimiento y para los cuales se le hubiese contratado.</li>
            </ol>
            
            <div style="text-align: right; margin: 1rem 0;">______________________________</div>
            
            <div class="declaration-title">Declara "EL(LA) TRABAJADOR(A)":</div>
            <ol class="declaration-list">
                <li>Ser persona física, de sexo <span class="text-bold">[sexo]</span>, de nacionalidad <span class="text-bold">[nacionalidad]</span>, de <span class="text-bold">[edad]</span> años de edad, de estado civil <span class="text-bold">[estado_civil]</span>, con CURP <span class="text-bold">[curp]</span>, con RFC <span class="text-bold">[rfc_trabajador]</span>, capaz para contratar y con la plena disposición, conocimientos, habilidades, experiencia y aptitudes para desempeñar el puesto de referencia en las declaraciones de "EL PATRÓN"</li>
                <li>Tener como domicilio el ubicado en: <span class="text-bold">[domicilio_particular]</span></li>
                <li>Tener como cuenta de correo electrónico para todos los efectos necesarios de comunicación, envío de CFDIS (nóminas timbradas), entre otras, el siguiente: <span class="text-bold">[email_trabajador]</span></li>
            </ol>
        </div>

        <p>De acuerdo con lo anteriormente establecido, es deseo de ambas partes sujetarse a las siguientes;</p>

        <div class="declaration-section">
            <h5>CLÁUSULAS:</h5>
            
            <ol class="clause-list">
                <li><span class="text-bold">PRIMERA.</span> "EL(LA) TRABAJADOR(A)" conviene en subordinarse hacia con "EL PATRÓN", con el fin de desempeñar el puesto y actividades referidas en las declaraciones de "EL PATRÓN".</li>
                
                <li><span class="text-bold">SEGUNDA.</span> El presente contrato se celebra por obra determinada de acuerdo con lo dispuesto en el artículo 36 de la Ley Federal del Trabajo. Lo anterior en virtud de los servicios contratados a "EL PATRÓN" y respecto a; <span class="text-bold">[cliente]</span>, mismos servicios que consisten en <span class="text-bold">[descripcion_obra]</span>.</li>
                
                <li><span class="text-bold">TERCERA.</span> Se hace constar que "EL PATRÓN" celebra el presente contrato fundado en la declaración de "EL(LA) TRABAJADOR(A)", en el sentido de que tiene los conocimientos, habilidades, experiencia y aptitudes necesarias para desempeñar las actividades para las que está siendo contratado(a).</li>
                
                <li><span class="text-bold">CUARTA.</span> Se hace constar que "EL(LA) TRABAJADOR(A)" prestará sus servicios en el domicilio precisado en las declaraciones de "EL PATRÓN" o bien, en el lugar que, según la naturaleza de los servicios contratados, estos deban desarrollarse.</li>
                
                <li><span class="text-bold">QUINTA.</span> "EL(LA) TRABAJADOR(A)" prestará los servicios indicados en este contrato directamente a "EL PATRÓN" y no a los clientes o proveedores de este, por lo que "EL PATRÓN" es su único patrón.</li>
                
                <li><span class="text-bold">SEXTA.</span> "EL PATRÓN" cubrirá a "EL(LA) TRABAJADOR(A)" por sus servicios, un salario <span class="text-bold">[temporalidad_pago]</span> bruto de $<span class="text-bold">[salario_numerico]</span> (<span class="text-bold">[salario_letra]</span> pesos 00/100 M.N.).</li>
                
                <li><span class="text-bold">SÉPTIMA.</span> El pago del salario anterior se hará <span class="text-bold">[dias_pago]</span>. Respecto al método de pago, éste será por regla general vía transferencia electrónica de fondos.</li>
                
                <li><span class="text-bold">OCTAVA.</span> "EL(LA) TRABAJADOR(A)" además de su salario, gozará de las vacaciones, prima vacacional y aguinaldo establecidos en la Ley Federal del Trabajo, proporcional al tiempo determinado en el presente contrato.</li>
                
                <li><span class="text-bold">NOVENA.</span> La jornada será <span class="text-bold">[tipo_jornada]</span> de <span class="text-bold">[horas_semanales]</span> semanales, con el siguiente horario: <span class="text-bold">[horario_trabajo]</span></li>
                
                <li><span class="text-bold">DÉCIMA.</span> Las partes convienen que "EL(LA) TRABAJADOR(A)" gozará de <span class="text-bold">[dias_descanso_semanal]</span> día(s) de descanso semanal, pactándose que este será <span class="text-bold">[dias_descanso_especificos]</span> cada semana.</li>
                
                <li><span class="text-bold">DECIMA PRIMERA.</span> "EL(LA) TRABAJADOR(A)" se obliga a mantener en estricta confidencialidad los documentos e información a la que tenga acceso con motivo de su relación laboral.</li>
                
                <li><span class="text-bold">DECIMA SEGUNDA.</span> "EL PATRÓN" impartirá capacitación y adiestramiento a "EL(LA) TRABAJADOR(A)" de acuerdo con los planes y programas registrados ante la STPS.</li>
                
                <li><spanspan class="text-bold">DECIMA QUINTA.</span> De acuerdo con lo dispuesto en el artículo 25, fracción X, de la ley federal del trabajo, "EL(LA) TRABAJADOR(A)" designa como sus beneficiarios a: <span class="text-bold">[beneficiarios]</span></li>
            </ol>
        </div>

        <p>
            Leído íntegramente el presente contrato por las partes y enterados de su alcance y fuerza legal, 
            "EL(LA) TRABAJADOR(A)" y "EL PATRÓN" lo ratifican y firman de conformidad por duplicado, 
            entregando copia de este al(a) trabajador(a), en la ciudad de <span class="text-bold">[lugar_ciudad]</span>, 
            el <span class="text-bold">[fecha_celebracion]</span>.
        </p>

        <div class="signature-section">
            <div class="signature-block">
                <div class="signature-line"></div>
                <p class="text-bold">EL PATRÓN</p>
                <p>[patron]</p>
            </div>
            
            <div class="signature-block">
                <div class="signature-line"></div>
                <p class="text-bold">EL(LA) TRABAJADOR(A)</p>
                <p>[colaborador]</p>
            </div>
        </div>

    </div>
</div>
`;

export const indeterminadoPruebaTemplate = `
    <div id="document-template" class="contract-template">
        <style>
            ul{
                list-style-type: upper-latin;
            }
            .contract-template {
                width: 210mm;
                min-height: 297mm;
                padding: 20mm;
                background: white;
                font-family: 'Arial', sans-serif;
                line-height: 1.6;
                box-sizing: border-box;
            }
            .contract-header {
                text-align: center;
                margin-bottom: 2rem;
                border-bottom: 2px solid #333;
                padding-bottom: 1rem;
            }
            .contract-header h1 {
                font-size: 18px;
                margin: 0;
                font-weight: bold;
            }
            .contract-content {
                font-size: 12px;
                text-align: justify;
            }
            .contract-content h5 {
                font-size: 12px;
                margin: 1rem 0 0.5rem 0;
                font-weight: bold;
            }
            .contract-content ol {
                margin: 0.5rem 0;
                padding-left: 1.5rem;
            }
            .contract-content li {
                margin-bottom: 0.3rem;
            }
            .contract-content b {
                font-weight: bold;
            }
            .confidential {
                color: #d32f2f;
                font-weight: bold;
                text-align: center;
                margin: 1rem 0;
                padding: 8px;
                border: 1px solid #d32f2f;
                background: #ffebee;
            }
        </style>

        <div class="contract-header">
            <h1>CONTRATO INDIVIDUAL DE TRABAJO POR OBRA DETERMINADA</h1>
        </div>

        <div class="contract-content">
            <p>
                Por medio del presente contrato individual de trabajo, comparece por una parte, 
                [patron], 
                representada por el(la) C. [representante_legal], 
                a quien en lo sucesivo se le denominará <b>"EL PATRÓN"</b>. 
                Por la otra parte, comparece el/la C. [colaborador], 
                quien comparece por su propio derecho y a quien en lo sucesivo se le denominará "EL(LA) TRABAJADOR(A)". 
                Ambos comparecientes, están de acuerdo en sujetarse al tenor de las siguientes declaraciones y cláusulas;
            </p>
            
            <p>
                <h5>DECLARACIONES:</h5>
                Declara "EL PATRÓN":
                <ol>
                    <li>Tener como principal actividad la de [actividad]</li>
                    <li>Tener su domicilio principal en [domicilio_fiscal]</li>
                    <li>Tener como RFC, el siguiente [rfc]</li>
                    <li>Que con fundamento en los artículos 36 de la ley federal del trabajo es deseo de "EL PATRÓN", contratar por obra determinada, los servicios de una persona que se pueda desempeñar en el puesto de [puesto], a fin de realizar las labores propias del puesto, tales como: [actividad]. Así como todas aquellas actividades o servicios que sean compatibles con sus fuerzas, aptitudes, estado o condición y que sea del mismo género de los que formen el objeto de la empresa o establecimiento y para los cuales se le hubiese contratado.</li>
                </ol>
            </p>
            
            <p>
                Declara "EL(LA) TRABAJADOR(A)":
                <ol>
                    <li>Ser persona física, de sexo [sexo]</li>
                    <li>Tener como fecha de nacimiento [fecha_nacimiento]</li>
                    <li>Contar con la siguiente identificación oficial [identificacion]</li>
                    <li>Tener como domicilio particular [domicilio_particular]</li>
                    <li>Contar con registro federal de contribuyentes [rfc_trabajador]</li>
                    <li>Tener como CURP [curp]</li>
                    <li>Contar con número de seguridad social [nss]</li>
                    <li>Estar de acuerdo en prestar sus servicios personales, subordinados y remunerados a "EL PATRÓN"</li>
                </ol>
            </p>

            <p>
                <h5>CLÁUSULAS:</h5>
                <ol>
                    <li><b>OBRA O SERVICIO:</b> "EL PATRÓN" contrata los servicios de "EL(LA) TRABAJADOR(A)" para que preste sus servicios profesionales para la obra o servicio consistente en: [descripcion_obra]</li>
                    <li><b>DURACIÓN:</b> La duración del presente contrato será por el tiempo que dure la obra o servicio antes descrito, mismo que se estima será de aproximadamente [duracion_estimada]</li>
                    <li><b>DOMICILIO:</b> "EL(LA) TRABAJADOR(A)" prestará sus servicios profesionales en [lugar_trabajo]</li>
                    <li><b>HORARIO:</b> El horario de trabajo será de [horario_trabajo]</li>
                    <li><b>SALARIO:</b> "EL PATRÓN" pagará a "EL(LA) TRABAJADOR(A)" por la obra realizada la cantidad de $[salario] MXN</li>
                    <li><b>FORMA DE PAGO:</b> El pago se realizará de la siguiente forma: [forma_pago]</li>
                    <li><b>TERMINACIÓN:</b> Una vez concluida la obra o servicio objeto del presente contrato, éste dará por terminado sin responsabilidad para "EL PATRÓN"</li>
                </ol>
            </p>

            <p>
                Leído que fue el presente contrato por las partes y estando de acuerdo con su contenido, lo firman por duplicado en el lugar y fecha arriba señalados.
            </p>

            <div style="display: flex; justify-content: space-between; margin-top: 3rem;">
                <div style="text-align: center;">
                    <p>_________________________</p>
                    <p><b>EL PATRÓN</b></p>
                    <p>[nombre_patron]</p>
                </div>
                
                <div style="text-align: center;">
                    <p>_________________________</p>
                    <p><b>EL(LA) TRABAJADOR(A)</b></p>
                    <p>[colaborador]</p>
                </div>
            </div>

            <div style="text-align: center; margin-top: 2rem; font-size: 10px; color: #666;">
                Documento generado el [fecha_generacion]
            </div>
        </div>
    </div>
    `;

export const indeterminadoCapacitacionTemplate = `
    <div id="document-template" class="contract-template">
        <style>
            ul{
                list-style-type: upper-latin;
            }
            .contract-template {
                width: 210mm;
                min-height: 297mm;
                padding: 20mm;
                background: white;
                font-family: 'Arial', sans-serif;
                line-height: 1.6;
                box-sizing: border-box;
            }
            .contract-header {
                text-align: center;
                margin-bottom: 2rem;
                border-bottom: 2px solid #333;
                padding-bottom: 1rem;
            }
            .contract-header h1 {
                font-size: 18px;
                margin: 0;
                font-weight: bold;
            }
            .contract-content {
                font-size: 12px;
                text-align: justify;
            }
            .contract-content h5 {
                font-size: 12px;
                margin: 1rem 0 0.5rem 0;
                font-weight: bold;
            }
            .contract-content ol {
                margin: 0.5rem 0;
                padding-left: 1.5rem;
            }
            .contract-content li {
                margin-bottom: 0.3rem;
            }
            .contract-content b {
                font-weight: bold;
            }
            .confidential {
                color: #d32f2f;
                font-weight: bold;
                text-align: center;
                margin: 1rem 0;
                padding: 8px;
                border: 1px solid #d32f2f;
                background: #ffebee;
            }
        </style>

        <div class="contract-header">
            <h1>CONTRATO INDIVIDUAL DE TRABAJO POR OBRA DETERMINADA</h1>
        </div>

        <div class="contract-content">
            <p>
                Por medio del presente contrato individual de trabajo, comparece por una parte, 
                [patron], 
                representada por el(la) C. [representante_legal], 
                a quien en lo sucesivo se le denominará <b>"EL PATRÓN"</b>. 
                Por la otra parte, comparece el/la C. [colaborador], 
                quien comparece por su propio derecho y a quien en lo sucesivo se le denominará "EL(LA) TRABAJADOR(A)". 
                Ambos comparecientes, están de acuerdo en sujetarse al tenor de las siguientes declaraciones y cláusulas;
            </p>
            
            <p>
                <h5>DECLARACIONES:</h5>
                Declara "EL PATRÓN":
                <ol>
                    <li>Tener como principal actividad la de [actividad]</li>
                    <li>Tener su domicilio principal en [domicilio_fiscal]</li>
                    <li>Tener como RFC, el siguiente [rfc]</li>
                    <li>Que con fundamento en los artículos 36 de la ley federal del trabajo es deseo de "EL PATRÓN", contratar por obra determinada, los servicios de una persona que se pueda desempeñar en el puesto de [puesto], a fin de realizar las labores propias del puesto, tales como: [actividad]. Así como todas aquellas actividades o servicios que sean compatibles con sus fuerzas, aptitudes, estado o condición y que sea del mismo género de los que formen el objeto de la empresa o establecimiento y para los cuales se le hubiese contratado.</li>
                </ol>
            </p>
            
            <p>
                Declara "EL(LA) TRABAJADOR(A)":
                <ol>
                    <li>Ser persona física, de sexo [sexo]</li>
                    <li>Tener como fecha de nacimiento [fecha_nacimiento]</li>
                    <li>Contar con la siguiente identificación oficial [identificacion]</li>
                    <li>Tener como domicilio particular [domicilio_particular]</li>
                    <li>Contar con registro federal de contribuyentes [rfc_trabajador]</li>
                    <li>Tener como CURP [curp]</li>
                    <li>Contar con número de seguridad social [nss]</li>
                    <li>Estar de acuerdo en prestar sus servicios personales, subordinados y remunerados a "EL PATRÓN"</li>
                </ol>
            </p>

            <p>
                <h5>CLÁUSULAS:</h5>
                <ol>
                    <li><b>OBRA O SERVICIO:</b> "EL PATRÓN" contrata los servicios de "EL(LA) TRABAJADOR(A)" para que preste sus servicios profesionales para la obra o servicio consistente en: [descripcion_obra]</li>
                    <li><b>DURACIÓN:</b> La duración del presente contrato será por el tiempo que dure la obra o servicio antes descrito, mismo que se estima será de aproximadamente [duracion_estimada]</li>
                    <li><b>DOMICILIO:</b> "EL(LA) TRABAJADOR(A)" prestará sus servicios profesionales en [lugar_trabajo]</li>
                    <li><b>HORARIO:</b> El horario de trabajo será de [horario_trabajo]</li>
                    <li><b>SALARIO:</b> "EL PATRÓN" pagará a "EL(LA) TRABAJADOR(A)" por la obra realizada la cantidad de $[salario] MXN</li>
                    <li><b>FORMA DE PAGO:</b> El pago se realizará de la siguiente forma: [forma_pago]</li>
                    <li><b>TERMINACIÓN:</b> Una vez concluida la obra o servicio objeto del presente contrato, éste dará por terminado sin responsabilidad para "EL PATRÓN"</li>
                </ol>
            </p>

            <p>
                Leído que fue el presente contrato por las partes y estando de acuerdo con su contenido, lo firman por duplicado en el lugar y fecha arriba señalados.
            </p>

            <div style="display: flex; justify-content: space-between; margin-top: 3rem;">
                <div style="text-align: center;">
                    <p>_________________________</p>
                    <p><b>EL PATRÓN</b></p>
                    <p>[nombre_patron]</p>
                </div>
                
                <div style="text-align: center;">
                    <p>_________________________</p>
                    <p><b>EL(LA) TRABAJADOR(A)</b></p>
                    <p>[colaborador]</p>
                </div>
            </div>

            <div style="text-align: center; margin-top: 2rem; font-size: 10px; color: #666;">
                Documento generado el [fecha_generacion]
            </div>
        </div>
    </div>
    `;
export const indeterminadoTemporadaTemplate = `
    <div id="document-template" class="contract-template">
        <style>
            ul{
                list-style-type: upper-latin;
            }
            .contract-template {
                width: 210mm;
                min-height: 297mm;
                padding: 20mm;
                background: white;
                font-family: 'Arial', sans-serif;
                line-height: 1.6;
                box-sizing: border-box;
            }
            .contract-header {
                text-align: center;
                margin-bottom: 2rem;
                border-bottom: 2px solid #333;
                padding-bottom: 1rem;
            }
            .contract-header h1 {
                font-size: 18px;
                margin: 0;
                font-weight: bold;
            }
            .contract-content {
                font-size: 12px;
                text-align: justify;
            }
            .contract-content h5 {
                font-size: 12px;
                margin: 1rem 0 0.5rem 0;
                font-weight: bold;
            }
            .contract-content ol {
                margin: 0.5rem 0;
                padding-left: 1.5rem;
            }
            .contract-content li {
                margin-bottom: 0.3rem;
            }
            .contract-content b {
                font-weight: bold;
            }
            .confidential {
                color: #d32f2f;
                font-weight: bold;
                text-align: center;
                margin: 1rem 0;
                padding: 8px;
                border: 1px solid #d32f2f;
                background: #ffebee;
            }
        </style>

        <div class="contract-header">
            <h1>CONTRATO INDIVIDUAL DE TRABAJO POR OBRA DETERMINADA</h1>
        </div>

        <div class="contract-content">
            <p>
                Por medio del presente contrato individual de trabajo, comparece por una parte, 
                [patron], 
                representada por el(la) C. [representante_legal], 
                a quien en lo sucesivo se le denominará <b>"EL PATRÓN"</b>. 
                Por la otra parte, comparece el/la C. [colaborador], 
                quien comparece por su propio derecho y a quien en lo sucesivo se le denominará "EL(LA) TRABAJADOR(A)". 
                Ambos comparecientes, están de acuerdo en sujetarse al tenor de las siguientes declaraciones y cláusulas;
            </p>
            
            <p>
                <h5>DECLARACIONES:</h5>
                Declara "EL PATRÓN":
                <ol>
                    <li>Tener como principal actividad la de [actividad]</li>
                    <li>Tener su domicilio principal en [domicilio_fiscal]</li>
                    <li>Tener como RFC, el siguiente [rfc]</li>
                    <li>Que con fundamento en los artículos 36 de la ley federal del trabajo es deseo de "EL PATRÓN", contratar por obra determinada, los servicios de una persona que se pueda desempeñar en el puesto de [puesto], a fin de realizar las labores propias del puesto, tales como: [actividad]. Así como todas aquellas actividades o servicios que sean compatibles con sus fuerzas, aptitudes, estado o condición y que sea del mismo género de los que formen el objeto de la empresa o establecimiento y para los cuales se le hubiese contratado.</li>
                </ol>
            </p>
            
            <p>
                Declara "EL(LA) TRABAJADOR(A)":
                <ol>
                    <li>Ser persona física, de sexo [sexo]</li>
                    <li>Tener como fecha de nacimiento [fecha_nacimiento]</li>
                    <li>Contar con la siguiente identificación oficial [identificacion]</li>
                    <li>Tener como domicilio particular [domicilio_particular]</li>
                    <li>Contar con registro federal de contribuyentes [rfc_trabajador]</li>
                    <li>Tener como CURP [curp]</li>
                    <li>Contar con número de seguridad social [nss]</li>
                    <li>Estar de acuerdo en prestar sus servicios personales, subordinados y remunerados a "EL PATRÓN"</li>
                </ol>
            </p>

            <p>
                <h5>CLÁUSULAS:</h5>
                <ol>
                    <li><b>OBRA O SERVICIO:</b> "EL PATRÓN" contrata los servicios de "EL(LA) TRABAJADOR(A)" para que preste sus servicios profesionales para la obra o servicio consistente en: [descripcion_obra]</li>
                    <li><b>DURACIÓN:</b> La duración del presente contrato será por el tiempo que dure la obra o servicio antes descrito, mismo que se estima será de aproximadamente [duracion_estimada]</li>
                    <li><b>DOMICILIO:</b> "EL(LA) TRABAJADOR(A)" prestará sus servicios profesionales en [lugar_trabajo]</li>
                    <li><b>HORARIO:</b> El horario de trabajo será de [horario_trabajo]</li>
                    <li><b>SALARIO:</b> "EL PATRÓN" pagará a "EL(LA) TRABAJADOR(A)" por la obra realizada la cantidad de $[salario] MXN</li>
                    <li><b>FORMA DE PAGO:</b> El pago se realizará de la siguiente forma: [forma_pago]</li>
                    <li><b>TERMINACIÓN:</b> Una vez concluida la obra o servicio objeto del presente contrato, éste dará por terminado sin responsabilidad para "EL PATRÓN"</li>
                </ol>
            </p>

            <p>
                Leído que fue el presente contrato por las partes y estando de acuerdo con su contenido, lo firman por duplicado en el lugar y fecha arriba señalados.
            </p>

            <div style="display: flex; justify-content: space-between; margin-top: 3rem;">
                <div style="text-align: center;">
                    <p>_________________________</p>
                    <p><b>EL PATRÓN</b></p>
                    <p>[nombre_patron]</p>
                </div>
                
                <div style="text-align: center;">
                    <p>_________________________</p>
                    <p><b>EL(LA) TRABAJADOR(A)</b></p>
                    <p>[colaborador]</p>
                </div>
            </div>

            <div style="text-align: center; margin-top: 2rem; font-size: 10px; color: #666;">
                Documento generado el [fecha_generacion]
            </div>
        </div>
    </div>
    `;

export const indeterminadoTemplate = `
    <div id="document-template" class="contract-template">
        <style>
            ul{
                list-style-type: upper-latin;
            }
            .contract-template {
                width: 210mm;
                min-height: 297mm;
                padding: 20mm;
                background: white;
                font-family: 'Arial', sans-serif;
                line-height: 1.6;
                box-sizing: border-box;
            }
            .contract-header {
                text-align: center;
                margin-bottom: 2rem;
                border-bottom: 2px solid #333;
                padding-bottom: 1rem;
            }
            .contract-header h1 {
                font-size: 18px;
                margin: 0;
                font-weight: bold;
            }
            .contract-content {
                font-size: 12px;
                text-align: justify;
            }
            .contract-content h5 {
                font-size: 12px;
                margin: 1rem 0 0.5rem 0;
                font-weight: bold;
            }
            .contract-content ol {
                margin: 0.5rem 0;
                padding-left: 1.5rem;
            }
            .contract-content li {
                margin-bottom: 0.3rem;
            }
            .contract-content b {
                font-weight: bold;
            }
            .confidential {
                color: #d32f2f;
                font-weight: bold;
                text-align: center;
                margin: 1rem 0;
                padding: 8px;
                border: 1px solid #d32f2f;
                background: #ffebee;
            }
        </style>

        <div class="contract-header">
            <h1>CONTRATO INDIVIDUAL DE TRABAJO POR OBRA DETERMINADA</h1>
        </div>

        <div class="contract-content">
            <p>
                Por medio del presente contrato individual de trabajo, comparece por una parte, 
                [patron], 
                representada por el(la) C. [representante_legal], 
                a quien en lo sucesivo se le denominará <b>"EL PATRÓN"</b>. 
                Por la otra parte, comparece el/la C. [colaborador], 
                quien comparece por su propio derecho y a quien en lo sucesivo se le denominará "EL(LA) TRABAJADOR(A)". 
                Ambos comparecientes, están de acuerdo en sujetarse al tenor de las siguientes declaraciones y cláusulas;
            </p>
            
            <p>
                <h5>DECLARACIONES:</h5>
                Declara "EL PATRÓN":
                <ol>
                    <li>Tener como principal actividad la de [actividad]</li>
                    <li>Tener su domicilio principal en [domicilio_fiscal]</li>
                    <li>Tener como RFC, el siguiente [rfc]</li>
                    <li>Que con fundamento en los artículos 36 de la ley federal del trabajo es deseo de "EL PATRÓN", contratar por obra determinada, los servicios de una persona que se pueda desempeñar en el puesto de [puesto], a fin de realizar las labores propias del puesto, tales como: [actividad]. Así como todas aquellas actividades o servicios que sean compatibles con sus fuerzas, aptitudes, estado o condición y que sea del mismo género de los que formen el objeto de la empresa o establecimiento y para los cuales se le hubiese contratado.</li>
                </ol>
            </p>
            
            <p>
                Declara "EL(LA) TRABAJADOR(A)":
                <ol>
                    <li>Ser persona física, de sexo [sexo]</li>
                    <li>Tener como fecha de nacimiento [fecha_nacimiento]</li>
                    <li>Contar con la siguiente identificación oficial [identificacion]</li>
                    <li>Tener como domicilio particular [domicilio_particular]</li>
                    <li>Contar con registro federal de contribuyentes [rfc_trabajador]</li>
                    <li>Tener como CURP [curp]</li>
                    <li>Contar con número de seguridad social [nss]</li>
                    <li>Estar de acuerdo en prestar sus servicios personales, subordinados y remunerados a "EL PATRÓN"</li>
                </ol>
            </p>

            <p>
                <h5>CLÁUSULAS:</h5>
                <ol>
                    <li><b>OBRA O SERVICIO:</b> "EL PATRÓN" contrata los servicios de "EL(LA) TRABAJADOR(A)" para que preste sus servicios profesionales para la obra o servicio consistente en: [descripcion_obra]</li>
                    <li><b>DURACIÓN:</b> La duración del presente contrato será por el tiempo que dure la obra o servicio antes descrito, mismo que se estima será de aproximadamente [duracion_estimada]</li>
                    <li><b>DOMICILIO:</b> "EL(LA) TRABAJADOR(A)" prestará sus servicios profesionales en [lugar_trabajo]</li>
                    <li><b>HORARIO:</b> El horario de trabajo será de [horario_trabajo]</li>
                    <li><b>SALARIO:</b> "EL PATRÓN" pagará a "EL(LA) TRABAJADOR(A)" por la obra realizada la cantidad de $[salario] MXN</li>
                    <li><b>FORMA DE PAGO:</b> El pago se realizará de la siguiente forma: [forma_pago]</li>
                    <li><b>TERMINACIÓN:</b> Una vez concluida la obra o servicio objeto del presente contrato, éste dará por terminado sin responsabilidad para "EL PATRÓN"</li>
                </ol>
            </p>

            <p>
                Leído que fue el presente contrato por las partes y estando de acuerdo con su contenido, lo firman por duplicado en el lugar y fecha arriba señalados.
            </p>

            <div style="display: flex; justify-content: space-between; margin-top: 3rem;">
                <div style="text-align: center;">
                    <p>_________________________</p>
                    <p><b>EL PATRÓN</b></p>
                    <p>[nombre_patron]</p>
                </div>
                
                <div style="text-align: center;">
                    <p>_________________________</p>
                    <p><b>EL(LA) TRABAJADOR(A)</b></p>
                    <p>[colaborador]</p>
                </div>
            </div>

            <div style="text-align: center; margin-top: 2rem; font-size: 10px; color: #666;">
                Documento generado el [fecha_generacion]
            </div>
        </div>
    </div>
    `;

